import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=31ec259c&scoped=true&"
import script from "./Tag.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Tag.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=31ec259c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ec259c",
  null
  
)

export default component.exports